import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGoogle, FaFacebook } from 'react-icons/fa';
// In Login.js, change the import to:
import supabase from '../../Services/Supabase';  // Correct casing
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '', // Cambiato da username a email
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
  
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      });
  
      if (error) throw error;
  
      if (data.session) {
        navigate('/admin', { replace: true });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>Accedi</h1>
          {/* <p>Please login to your account</p> */}
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="email" // Cambiato da text a email
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          {error && <p style={{ color: 'red' }}>{error}</p>} {/* Mostra errori */}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Caricamento...' : 'Login'}
          </button>
        </form>

        <div className="social-login">
          <p>Oppure continua con</p>
          <div className="social-buttons">
            <button className="social-button google">
              <FaGoogle /> Google
            </button>
            <button className="social-button facebook">
              <FaFacebook /> Facebook
            </button>
          </div>
        </div>

        {/* <div className="back-to-main">
          <button onClick={() => navigate('/')} className="back-button">
            <span className="back-arrow">←</span> Indietro
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
